<template>
  <v-container>
    <v-toolbar flat color="white">
      <v-toolbar-title class="mr-2">{{
        reseller ? $store.state.auth.user.reseller.name : ""
      }}</v-toolbar-title>
      <v-divider vertical class="mr-2"></v-divider>
      <v-toolbar-title>{{
        $t("Customization of applications")
      }}</v-toolbar-title>
      <v-spacer></v-spacer>
    </v-toolbar>
    <v-card class="mb-5">
      <customization-toolbar></customization-toolbar>
      <v-card-text>
        <customization-app-preview></customization-app-preview>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import { mapState } from "vuex";
import CustomizationToolbar from "@/components/CustomizationToolbar";
import CustomizationAppPreview from "@/components/CustomizationAppPreview";

export default {
  name: "Customization",
  components: { CustomizationToolbar, CustomizationAppPreview },
  computed: {
    ...mapState({
      entities: (state) => state.entities.items,
      reseller: (state) => state.auth.user.reseller.id,
      primaryColor: (state) => state.customizations.primaryColor,
    }),
    editedItem: {
      get() {
        return this.$store.state.customizations.editedItem;
      },
      set(value) {
        this.$store.commit("customizations/setEditedItem", value);
      },
    },
  },
  watch: {
    entities(value) {
      this.$store.commit("customizations/setEntityId", value[0].id);
      this.$store.dispatch("customizations/fetch");
    },
  },
  created() {
    if (this.entities.length > 0) {
      this.$store.commit("customizations/setEntityId", this.entities[0].id);
      this.$store.dispatch("customizations/fetch");
    }
  },
};
</script>